export const numbers = /^\d$/;
export const postiveNumbers = /\D/g;
export const startsWithZero = /^0/;
export const lettersOrPunctuation = /[a-zA-Z]|[ ,/`\-=\\\[\];'~_+|{}:"<>?!@#$%^&*()]/;
export const ipNumber = /^((\d{1,3})[.]){3}(\d{1,3})$/;
export const domainNameSystemRegex = /^[a-zA-Z0-9.*-]+$/;
export const urlRegex = /^(https?:\/\/)([^:/\s]+)(:\d+)?(\/.*)?$/;
export const fullStop = /[.]/;
export const fullStopGlobal = /[.]/g;
export const precedingZeros = /[.]{0,1}[^1-9]*[0]$/;
export const precedingIPTerm = /\d{3}$/;
export const hexPattern: RegExp = /^[0-9A-Fa-f]+$/;
export const namePattern = /\b.*(name)\b(?!w)|(trn-name)|(lm-message)|(md-val-string)/;
export const filterPreferencePattern = /department|site|company|access-time-pattern|zone|area|door|location|category|event-type|building|floor|device-improx|profile|access-group|time-pattern|master-detail|master|long-message/
export const upperCase = /[A-Z]/;
export const lowerCase = /[a-z]/;
export const digit = /\d/;
export const specialChar = /[!@#$%^&*(),.?":{}|<>]/;
export const alphaNumericRegex = /^[a-zA-Z0-9]+$/;
export const alphabetRegex = /[A-Za-z]/;
export const colonDashRegex = /[:-]/g;
export const characterMoreThanTwoRepetition = /(.)\1{2,}/;
export const characterSequence = /(?:abc|bcd|cde|def|efg|fgh|ghi|hij|ijk|jkl|klm|lmn|mno|nop|opq|pqr|qrs|rst|stu|tuv|uvw|vwx|wxy|xyz|cba|dcb|edc|fed|gfe|hgf|ihg|jih|kjih|lkj|mlk|nml|onm|pon|qpo|rqp|srq|tsr|uts|vut|wvu|xwv|yxw|zyx|012|123|234|345|456|567|678|789|210|321|432|543|654|765|876|987)/
export const emptyString = /\s/;

export const findMatchingAttribute = (data : Object, pattern: RegExp) => {
    return Object.entries(data)
        .find(([key, value]) => {
            return value !== null && pattern.test(key);
        });
}
